import React from "react";
import { arrayOf, bool, node, string } from "prop-types";
import { unitShape } from "../../common/unit.js";
import Card from "../Card/Card.jsx";
import Results from "../Results/Results.jsx";
import ResultsHeader from "../Results/ResultsHeader.jsx";

const propTypes = {
  isLoading: bool,
  header: node,
  pagination: node,
  resultsRange: node,
  units: arrayOf(unitShape).isRequired,
  title: string,
};

const UnitList = props => {
  const { isLoading, pagination, resultsRange, units, title } = props;

  return (
    <div className="unit-list">
      <Results
        isLoading={isLoading}
        header={
          <ResultsHeader
            title={title}
            resultsRange={resultsRange}
            showSort={true}
          />
        }
        pagination={pagination}
      >
        {units.length === 0 && !isLoading
          ? "No results, try changing some filters above."
          : units.map(unit => {
              const {
                area,
                availableDate,
                displayDate,
                bathrooms,
                bedrooms,
                id,
                image,
                matterportId,
                selfguidedTour,
                price,
                unitNumber,
                url,
              } = unit;

              const date = new Date(availableDate);
              const now = new Date();
              const moveInText =
                date < now ? "Available Now" : `Move-in ${displayDate}`;

              return (
                <Card
                  key={id}
                  detailUrl={url}
                  detailButton="Details"
                  title={unitNumber}
                  image={
                    <img src={image} alt={`Unit ${unitNumber} floor plan`} />
                  }
                  matterportId={matterportId}
                  selfguidedTour={selfguidedTour}
                  stats={[
                    `${area} Sq. Ft.`,
                    bedrooms,
                    bathrooms,
                    `Starting at ${price}`,
                  ]}
                >
                  <ul className="unit-list__move-in">
                    <li>{moveInText}</li>
                  </ul>
                </Card>
              );
            })}
      </Results>
    </div>
  );
};

UnitList.propTypes = propTypes;
export default UnitList;
